import LiveFlightsPage from "./live-flights-page";
export default LiveFlightsPage;